import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ADMIN_DASHBOARD } from '@ApplicationWide/permissions/constants';
import React from 'react';

const OffboardingPage = React.lazy(() => import('../../../pages/Admin/Offboarding'));

export default [
  {
    group: ADMIN,
    to: '/administration/offboarding',
    route: ['/administration/offboarding', '/administration/offboarding/:userId'],
    component: OffboardingPage,
    requiredRoles: ['admin', 'super_admin', 'manager'],
    adminVisibilityPermission: ADMIN_DASHBOARD,
    hasNavBar: true,
  },
];
